export interface Project {
  slug: 'gatorade' | 'rapid-reboot' | 'stand-plus' | 'frosted-flakes'
  name: string
  category: string
  coverSubject: string
  coverImage: string
  coverVideo?: string
  overview: string
  deliverables: string[]
  gallery?: string[]
}

export const projects: Project[] = [
  {
    slug: 'frosted-flakes',
    name: 'Frosted Flakes X JID X Since the 80s',
    category: 'Sports Marketing · Brand Partnership',
    coverSubject: 'JID · Since the 80s',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/kCb8cqHs5jrE8pDsTb1uKd/AI6A3829.jpg',
    coverVideo:
      'https://cdn.magicpatterns.com/uploads/4dLVnmw3qt3cRV9t1pNRom/SinceThe80sRecap.mov',
    overview:
      "Iconic brand, new energy. We brought JID, athletes, and culture together for Frosted Flakes — connecting a legacy name to the next generation of greatness. They're not just great. They're our kind of great.",
    deliverables: [
      'Sports marketing partnership strategy',
      'JID and athlete-led campaign creative direction',
      'Integrated content toolkit for social and brand channels',
    ],
    gallery: [
      'https://cdn.magicpatterns.com/uploads/dGodVFCBxYp6yWwQF1gkCu/AI6A3729.jpg',
      'https://cdn.magicpatterns.com/uploads/hNtioWyszowAQqVEu5GeRC/AI6A3829.jpg',
      'https://cdn.magicpatterns.com/uploads/4UAdNC19RYvRcdZ1xU53Zi/AI6A3852.jpg',
      'https://cdn.magicpatterns.com/uploads/3AkjMFGWtNKChEdkBVSV51/AI6A3999.jpg',
      'https://cdn.magicpatterns.com/uploads/oQ34B4SbztM8YfoPJpbgfh/AI6A4006.jpg',
      'https://cdn.magicpatterns.com/uploads/cvVj9cT2Db7FPXwe8EdEvZ/AI6A4007.jpg',
      'https://cdn.magicpatterns.com/uploads/rRi1y2GCx26tEv3e3ez68q/AI6A4010.jpg',
      'https://cdn.magicpatterns.com/uploads/7TBSceDhs2TNfMMK9BxVKJ/AI6A4050-2.jpg',
      'https://cdn.magicpatterns.com/uploads/8manekuCtdA1LnomVv7mGe/AI6A4050.jpg',
      'https://cdn.magicpatterns.com/uploads/kNJVdtv7HrKvva877p2TEQ/AI6A4087.jpg',
      'https://cdn.magicpatterns.com/uploads/b9U9tMbHQD6KgaEHks2o2a/AI6A4088.jpg',
      'https://cdn.magicpatterns.com/uploads/7vo1YUne3cbQLeNmQCZBcZ/AI6A4218.jpg',
    ],
  },
  {
    slug: 'gatorade',
    name: 'Gatorade',
    category: 'Sports Marketing · Content',
    coverSubject: 'Deuce Edwards',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/9kgCi8RXCjGoQoqSGakFvv/Screenshot_2026-07-22_at_11.28.17_AM.png',
    coverVideo:
      'https://cdn.magicpatterns.com/uploads/xp1Cb9e47f9owvnAH7nx46/Deuce_Edwards_Gatorade_compressed.mp4',
    overview:
      "We partnered with Gatorade to bring authentic athlete culture to the forefront — putting real stories in front of the right audiences. Deuce Edwards wasn't just a face. He was the proof.",
    deliverables: [
      'Campaign strategy and audience positioning',
      'Athlete-led photo and short-form video production',
      'Social-first storytelling across launch platforms',
    ],
  },
  {
    slug: 'rapid-reboot',
    name: 'Rapid Reboot',
    category: 'Brand Partnership · Content',
    coverSubject: 'Mario Anderson',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/gbxWV3J2JPT8y8KJbo3T1s/Mario_Rapid_Reboot.jpg',
    coverVideo:
      'https://cdn.magicpatterns.com/uploads/nKjFYtLDoFqNtHb8sW3uKU/Mario Anderson_Rapid Reboot_Reel.mov',
    overview:
      "Recovery isn't just physical — it's mental. We helped Rapid Reboot connect with athletes who live that truth, building content that felt less like an ad and more like a conversation.",
    deliverables: [
      'Brand partnership concept and campaign narrative',
      'Athlete interview and recovery-day content',
      'Editorial social cutdowns for organic distribution',
    ],
  },
  {
    slug: 'stand-plus',
    name: 'Stand +',
    category: 'Brand Strategy · Content',
    coverSubject: 'Mario Anderson',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/b6N32jzsUSyvqAeTjhtC7x/Photo_2025-05-09_10.46.33_AM.jpg',
    coverVideo:
      'https://cdn.magicpatterns.com/uploads/iSjiBvesue2y3PHWLe4zNA/4-3_Stand Copy 01_1.mov',
    overview:
      "Stand + isn't just a brand. It's a stance. We built creative that matched the conviction — content rooted in culture, built for the people who move with purpose.",
    deliverables: [
      'Brand strategy and core campaign positioning',
      'Creative direction for athlete-led visual storytelling',
      'Culture-forward social content and launch assets',
    ],
    gallery: [
      'https://cdn.magicpatterns.com/uploads/463vRhGrYhBh5a5uL8Cnjs/Mario_Stand-2.jpg',
      'https://cdn.magicpatterns.com/uploads/gNpMAu67V2BkekUjVRRpw6/Mario_Stand.jpg',
      'https://cdn.magicpatterns.com/uploads/gKKaeZZz9TFTC6gbz7Wjif/Photo_2025-05-09_10.46.33_AM.jpg',
    ],
  },
]
